import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { SessionTimeoutService } from '../app/service/session-timeout.service';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ErrorPageComponent } from './pages/ErrorPages/error-page/error-page.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, LayoutComponent, LoginComponent,ChangePasswordComponent,ErrorPageComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  showContent = true;
  currentRoute?: string;
  constructor(private router: Router, private sessionTimeoutService: SessionTimeoutService) { }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
        this.showContent = !(event.url === '/Login' || event.url === '/' || event.url === '/ForgetPassword' || event.url.startsWith('/Error'));
      }
    });
  }

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  handleUserActivity() {
    this.sessionTimeoutService.resetTimer();
  }

}
